(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jj-step-by-step-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stepItems = document.querySelectorAll('.how-it-works-container .step-item');

    stepItems.forEach(item => {
      // Find the actual <video> element within the step item
      const video = item.querySelector('video');

      if (video) {
        // Ensure the video is muted, as required by modern browsers for autoplay
        video.muted = true;
        video.setAttribute('muted', ''); // For good measure

        item.addEventListener('mouseenter', () => {
          // Play the video and handle any browser restrictions
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch(error => {
              // This catch block will handle cases where the browser prevents autoplay.
              // The video will still play if the user has interacted with the site before.
              console.error("Video autoplay was prevented by the browser:", error);
            });
          }
        });

        item.addEventListener('mouseleave', () => {
          // Pause and reset the video to the beginning when the mouse leaves
          video.pause();
          video.currentTime = 0;
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
